import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import SATracking from '@/shared/saTracking';
import { ref } from 'vue';
var __default__ = {
    inheritAttrs: false
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    __name: 'checkbox-with-tracking',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        shape: {
            type: String,
            validator: function validator(val) {
                return [
                    'square',
                    'round'
                ].includes(val);
            },
            default: 'square'
        },
        iconSize: {
            type: [
                String,
                Number
            ],
            default: '15px'
        }
    },
    emits: [
        "input"
    ],
    setup: function setup(__props, param) {
        var emit = param.emit;
        var checkbox = ref(null);
        var onInput = function onInput(value) {
            var _checkbox_value;
            emit('input', value);
            if ((_checkbox_value = checkbox.value) === null || _checkbox_value === void 0 ? void 0 : _checkbox_value.$el) {
                SATracking.trackClick(checkbox.value.$el, {
                    desc: value ? '选中' : '取消'
                });
            }
        };
        return {
            __sfc: true,
            emit: emit,
            checkbox: checkbox,
            onInput: onInput
        };
    }
}));
